// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.root__DefaultLayout_r2vRD {\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.content__DefaultLayout_2qXG9 {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n  height: calc(100vh - 20px);\n}\n.content-root__DefaultLayout_1Ww9i {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "root__DefaultLayout_r2vRD",
	"content": "content__DefaultLayout_2qXG9",
	"content-root": "content-root__DefaultLayout_1Ww9i",
	"contentRoot": "content-root__DefaultLayout_1Ww9i"
};
module.exports = exports;
